import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'

const featureContent = [
    
    {
        arrow: 'bi bi-arrow-up-right',
        frontIcon: 'classroom-w',
        backIcon: 'classroom-b',
        title: 'Education & Research',
        desc: 'Empowering individuals through education & research for a brighter future.',
        dataAos: 'fade-up',
        dataDelay: '',
        url: '/sector-categories/education',
        img: 'edu.jpg',
    },

    {
        arrow: 'bi bi-arrow-up-right',
        frontIcon: 'healthcare-w',
        backIcon: 'healthcare-b',
        title: 'Healthcare',
        desc: 'Providing products and services to improve the healthcare system in the country.',
        dataAos: 'fade-up',
        dataDelay: '100',
        url: '/sector-categories/healthcare',
        img: 'pharmacy.jpg',
    },

    {
        arrow: 'bi bi-arrow-up-right',
        frontIcon: 'Media Icon White',
        backIcon: 'Media Icon Black',
        title: 'Media',
        desc: 'Creating outreach and engagement opportunities through marketing & communication.',
        dataAos: 'fade-up',
        dataDelay: '200',
        url: '/sector-categories/Media',
        img: 'manpower.jpg',
    },

    {
        arrow: 'bi bi-arrow-up-right',
        frontIcon: 'Investment Icon White',
        backIcon: 'Investment Icon Black',
        title: 'Investment',
        desc: ' Contributing to dynamic capital growth through strategic investment and asset trading.',
        dataAos: 'fade-up',
        dataDelay: '',
        url: '/sector-categories/Investment',
        img: 'ParadiseCorp Web Banners.jpg',
    }
];

const AllSectors = () => {
    return (
        <>
            {featureContent.map((val, i) => (
                <div key={i} className="col-lg-3 col-md-6 mb-4" data-aos={val.dataAos} data-aos-delay={val.dataDelay}>
                    <div className="feature-style-one mb-45 h-100 d-flex flex-column" style={{padding: '20px'}}>
                        <Link to={`${val.url}`}>
                            <a className="top-arrow">
                                <i className={val.arrow} />
                            </a>
                        </Link>
                        <div className="d-flex align-items-center mb-3">
                            <img className="front-icon me-3" src={`assets/img/icon/${val.frontIcon}.png`} alt="icon" />
                            <img className="back-icon me-3" src={`assets/img/icon/${val.backIcon}.png`} alt="icon" />
                            <h4 className="mb-0 feature-title">
                                <Link to={`${val.url}`}>{val.title}</Link>
                            </h4>
                        </div>
                        <Link to={`${val.url}`} style={{display: 'block'}}>
                            <img className='w-100 mb-3 banner-img' src={`assets/img/sectors/${val.img}`} alt="img" style={{height: 220, objectFit: 'cover', display: 'block', borderRadius: 2}} />
                        </Link>
                        <p className='flex-grow-1'>{val.desc}</p>
                        <div className='text-center mt-3'>
                            <Link to={`${val.url}`}>Read More</Link>
                        </div>
                    </div>
                </div>
            ))}
        </>
    )
}

export default AllSectors